import cssVars from 'css-vars-ponyfill'

const THEME_STORAGE_KEY = 'DF_THEME_COLOR'

export function hexToRgba(hex, alpha) {
  const cleanHex = hex.replace('#', '');

  const fullHex = cleanHex.length === 3
    ? cleanHex.split('').map(c => c + c).join('')
    : cleanHex;

  const r = parseInt(fullHex.slice(0, 2), 16);
  const g = parseInt(fullHex.slice(2, 4), 16);
  const b = parseInt(fullHex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}


export function setThemeColor(color) {
    if(color) {
      window.globalColor = color
    }
    cssVars({
        watch: true, // 当 CSS 变量发生变化时自动更新
        variables: {
          '--df-primary-color': color,
          '--df-primary-color-opacity': hexToRgba(color, 0.1)
        }
    })
}

export function readThemeColor() {
    try {
      const cached = localStorage.getItem(THEME_STORAGE_KEY)
      let color = null
      if(cached) {
        color = JSON.parse(cached).globalThemeColor
      }
      return color
    } catch {
      return null
    }
}

export function writeThemeColor(theme) {
    try {
      if(theme){
        localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(theme))
      }
    } catch {}
}